import {RequestStatus, RequestStatusesEnum} from '@shared/core';

export const checkStatus = (status: RequestStatus) =>
  status === RequestStatusesEnum.Approved ||
  status === RequestStatusesEnum.Rejected ||
  status === RequestStatusesEnum.Canceled ||
  status === RequestStatusesEnum.Delayed;

export default checkStatus;
